import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import naim from "../../images/Naim.jpg";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div id="about" className="container about mt-5 pt-5 mb-5">
      <h1 className="d-flex align-items-center text-white font-weight-bold mb-5 pb-3 justify-content-center">
        About Me
      </h1>
      <div className="row d-flex align-items-center justify-content-around">
        <div data-aos="slide-up" className="col-md-4 img-size">
          <img
            style={{
              borderRadius: "5%",
              margin: "0 auto",
              display: "block",
            }}
            className="mb-3"
            src={naim}
            height="270px"
            alt="Naimul Alam"
          />
        </div>
        <div data-aos="slide-up" className="col-md-5 about-mySelf">
          <p className="text-white">
            Hello, I’m Naim, a courteous and enthusiastic, IT graduate who loves
            everything in its orbit. As this area complements my studies, so
            want to enrich my experience in this field. My core skill is based
            on JavaScript and I love to do most of the things using JavaScript.
            I love to make the web more open to the world. I’m currently
            studying IT in Business: Web App Developer (4th Semester) at WSB
            University, Poland.
          </p>
          <a
            href="https://github.com/NaimulAlam/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <button className="btn btn-outline-primary text-white my-2 my-sm-0">
              Github
            </button>
          </a>
          <a href="#skills">
            <button className="btn btn-outline-primary text-white my-2 my-sm-0 ml-3">
              My Skills
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
